
import AlertDetails from './AlertDetails'

export default {
  name: 'AlertDetailsModal',
  components: { AlertDetails },
  props: {
    alertId: { type: Number, required: true }
  },

  data () {
    return {
      alert: null
    }
  },

  async mounted () {
    document.body.style.overflow = 'hidden'

    const { data } = await this.$axios
      .get(`v1/alerts/${this.alertId}`, { xhrLoader: true })
      .catch(() => this.close())

    this.alert = data
  },

  methods: {
    close (event) {
      if (event && event.target !== this.$refs.backdrop) {
        return
      }

      this.$emit('close')
    }
  }
}
